/* RESPONSIBLE TEAM: team-actions */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class StandaloneProcedureController extends Controller {
  queryParams = ['aiDraft'];

  @tracked aiDraft: string | null = null;
}
